export default {
    INACTIVE: 'inactive',
    WAITING: 'waiting',
    IN_PROGRESS: 'in progress'
};
